module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j88tc"))).then(() => parcelRequire('6JUDa'));